import type { Room } from "../rooms/roomTypes";
import type { DocEntityHandle } from "./docEntityHandleTypes";

/**
 * Creates a DocEntityHandle for selecting the reporting unit based on a Room.
 * Supports also component instanced rooms.
 */
export function roomEntityHandleForSelectingReportingUnit(room: Room | null | undefined): DocEntityHandle | undefined {
  if (room?.instanceId) {
    return { type: "COMPONENT_INSTANCE", id: room.instanceId };
  }
  return room?.roomHandle;
}
